import { Observable } from "rxjs";
import { map, first } from "rxjs/operators";

export function AlreadyTaken(check: string, checkList: Observable<string[]>) {
    return checkList.pipe(first(), map(list => {
        return list.includes(check) ? { alreadyTaken: true } : null;
    }));
}